module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	'use strict';
	fox.registerWidget('WelcomeBanner', {
		configure: function (options) {
			this.registerOptions('', {
				fakePlayerButton: 'fake_player_button',
				widgets: {
					api: {
						widget: 'Api',
						method: 'site.welcome.get',
						cacheChannel: 'site',
						group: 'api'
					},
					video: {
						widget: 'Content_Html5Player',
						container: '.player-wrapper',
						template: 'sitepage_home_welcome_video',
						active: false,
						autoRender: true,
						renderPlayer: true,
						renderTo: '.player',
						onPausePlayerImage: fox._isNewFe ? require('../images/player_banner.png') : (fox.getEnv('design.url') + '/images/player_banner.png'),
						'html5PlayerConfig.plugins.controls.togglefullscreen': false,
						//'html5PlayerConfig.movie.autoplay': !!Number(fox.getEnv('siteProps.welcomeVideoAutoplay')) && !!Number(fox.cookie.get('splash')),
						'html5PlayerConfig.movie.autoplay': !!Number(fox.getEnv('siteProps.welcomeVideoAutoplay')),
						'html5PlayerConfig.plugins.controls.autoHide': true,
						'hooks.onBannerLoadError': fox.bind(this._handleWBLoadError, this)
					},
					banner: {
						active: false,
						autoRender: true,
						widget: 'Widget',
						template: 'sitepage_home_welcome_banner'
					},
					none: {
						active: false,
						autoRender: true,
						widget: 'Widget',
						template: 'sitepage_home_welcome_none'
					}
				}
			});

			this.callParent('configure', arguments);
		},

		init: function() {
			this.registerOptions('.Widget', {
				active: false,
				'container': this.getOption('container')
			});
			this.callParent('init', arguments);
		},

		deactivate: function (argument) {
			this.callParent('deactivate', arguments);
			this.dispatchEvent('deactivate');
		},

		sendApi: function () {
			var api = this.wom1('#api');

			if (api) {
				api.send();
			}
		},

		initWithChildren: function() {
			if (this.getOption('video.url')) {
				this.showHanlder({
					welcomeVideo: this.getOption('video.url')
				});
			} else {
				this.handleEvent('#api', 'ready', 'showHanlder');
				this.sendApi();
			}

			return this.callParent('init', arguments);
		},

		showHanlder: function(params) {
			this.welcomeData = params;
			this.hookWrapper('renderWelcomeData', params);
		},

		renderWelcomeData: function (params) {
			var alias = 'none';
			var v;
			if (!fox.isEmpty(params.welcomeVideo) &&
				!fox.inArray(['error', 'encoding'], params.welcomeVideo.split(':').shift())) {

				v = this.rwom1('#video');
				alias = 'video';
				v.setOption('videoUrl', params.welcomeVideo);

				if (!fox.isEmpty(params.welcomeBanner)) {
					v.setPoster(params.welcomeBanner);
				}

			} else if (!fox.isEmpty(params.welcomeBanner)) {
				v = this.rwom1('#banner');
				alias = 'banner';
				v.templateOptions.src = params.welcomeBanner;
			}
			
			if (!this.switchEmbeddedWidget(alias)) {
				this.rwom1('#' + alias).render();
			}
		},

		renderBanner: function (tplOpts) {
			var alias = 'banner';
			var w = this.rwom1('#' + alias);

			if (tplOpts) {
				w.templateOptions = tplOpts;
			}

			if (!this.switchEmbeddedWidget(alias)) {
				w.render();
			}
		},

		renderPlayer: function (params) {
			var alias = 'video';
			var w = this.rwom1('#' + alias);

			w.setOption('videoUrl', params.welcomeVideo);
			
			if (!this.switchEmbeddedWidget(alias)) {
				w.render();
			}
		},

		renderEmptyPlaceholder: function () {
			var alias = 'none';
			var w = this.rwom1('#' + alias);

			if (!this.switchEmbeddedWidget(alias)) {
				w.render();
			}
		},

		_handleWBLoadError: function (data) {
			var ev = data.e;
			var img = ev.srcElement || ev.target;
			var parent = img.parentNode;

			if (ev.type === 'error') {
				fox.dom.addClass('error', parent);
				parent.innerHTML = '';
				parent.appendChild(
					fox._isNewfe ?
						this.getTemplater('fakePlayerButton') :
						fox.Zen(this.getOption('fakePlayerButton'))
				);
			}
		}

	},  'Controller');
}) (fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/welcomebanner.js
// module id = 955
// module chunks = 4